import { render, staticRenderFns } from "./info.vue?vue&type=template&id=afac3616&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=afac3616&prod&lang=scss"
import style1 from "./info.vue?vue&type=style&index=1&id=afac3616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afac3616",
  null
  
)

export default component.exports